/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\CarCost.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Monday, February 13th 2023, 5:00:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const CarCostSellPrice = styled.div.attrs((props: any) => ({
    fontColor: props.fontColor,
}))`
display: flex;
justify-content: center;
align-items: center;
position: relative;
top: -0.4rem;
left: 7rem;
margin-bottom: 0;
max-width: 75px;
height: 2rem;
font-family: var(--theme-text-Montserrat-semi-bold);
border-radius: 5px;
border-bottom-right-radius: 10px;
border-bottom: ${(props: any) => getThemeColor(props.fontColor)} 2px solid;
border-right: ${(props: any) => getThemeColor(props.fontColor)} 2px solid;
color: ${(props: any) => getThemeColor(props.fontColor)};
background-color: var(--bg-color-first);
`;

export default CarCostSellPrice;
